const reportDB = require('../../../../../components/report/report-db')
const report = require('../../../../../components/report/report')
const style = require('../../../../../components/report/report-style')
const { getReportInsertTarget } = require('../../../../../components/report/report-target')
const css = style.get()
const settings = require('../../../../../js-handler/settings')
const timeDate = require('../../../../../js-handler/time-date')
const timeTime = require('../../../../../js-handler/time-time')
const math = require('../../../../../js-handler/math')

export function start(detail) {

    const phpFile = 'server/php/sql/report.php'

    if (detail.source == 'fullcont') {
        const fullcontCustomer = document.getElementById('customer-fullcont')
        let dataDbid = '';
        dataDbid = fullcontCustomer.getAttribute('data-dbid')
        detail.inf = { entity: 'customer', report: 'customer-profit-one', id: dataDbid }

        reportDB.select(detail, phpFile, (data) => {

            insert(detail, data)

        })
    } else if (detail.source == 'dt') {
        let dataDbid = '';
        dataDbid = detail.dbid
        detail.inf = { entity: 'customer', report: 'customer-profit-one', id: dataDbid }

        reportDB.select(detail, phpFile, (data) => {

            insert(detail, data)

        })
    } else if (detail.source === 'hub-one') {
        detail.inf = { entity: 'customer', report: 'customer-profit-one', id: detail.dbid }

        reportDB.select(detail, phpFile, (data) => {

            insert(detail, data)

        })
    } else {
        detail.inf = { entity: 'customer', report: 'customer-profit-all' }

        reportDB.select(detail, phpFile, (data) => {

            insert(detail, data)

        })
    }


}/**/

function insert(detail, data) {
    const pageTarget = getReportInsertTarget(detail, 'customer-page-right')
    if (!pageTarget) return
    const body = generate(data)

    pageTarget.insertAdjacentHTML("beforeend", body)
}

function generate(rawData) {
    const data = Array.isArray(rawData) ? rawData : [rawData];

    var body = ''
    body += generateHeader()
    body += generateTop(data)
    body += generateTable(data)
    body += `</div> `
    body += `<div class="report-page">`

    return body
}

function generateHeader() {
    var header = ''
    header += `<div class="report-page" id="miDiv5" ${css.table}>`
    header += `
                    <div class="report-appbar report-appbar-black" >
                            <div  data-detail='{"click": [ 
                                                        {"dest":"ripple" }, 
                                                        {"dest":"report", "act":"remove" } ] }' >
                                <svg><use xlink:href="../css/svg.svg#close"></use></svg>
                            </div>

                            <h1>All Customers Statement: Accounts Profits All Report</h1>

                        <div class="fr" data-detail='{"click": [ 
                                                    {"dest":"ripple" }, 
                                                    {"dest":"report", "act":"print" }  ] }' >
                                <svg><use xlink:href="../css/svg.svg#print"></use></svg>
                                <label>Print</label>
                        </div>
                    </div> `

    header += `
                    <div class="dataCont">
                        <h1  ${css.f32}></h1>
                        <p   ${css.f14} ></p>
            `
    return header
}

function generateTop(data) {
    let company_name = "";
    let current_dateTime = "";

    if (data && data.length > 0 && data[0]) {
        company_name = data[0].company_name || "";
        current_dateTime = data[0].current_dateTime || "";
    } else {
        let config = settings.getData()
        company_name = config.company;
        current_dateTime = timeDate.getdateshort() + ' ' + timeTime.formatAMPM();
    }

    var table = `<br><br><h1 style="text-align: center;">${company_name}</h1>
      <h2 style="text-align: center;">Accounts Profits All Report As Of ${current_dateTime}</h2>
      <h2 style="text-align: center;"></h2>
      `;

    return table;
}

function generateTable(data) {
    var totals = {
        total_last_24_hours: 0,
        total_last_24_hours_income: 0,
        total_last_7_days: 0,
        total_last_7_days_income: 0,
        total_last_15_days: 0,
        total_last_15_days_income: 0,
        total_last_30_days: 0,
        total_last_30_days_income: 0,
        total_last_90_days: 0,
        total_last_90_days_income: 0,
        total_over_90_days: 0,
        total_over_90_days_income: 0,
        grandTotal: 0
    };
    var nextFormat = 0;

    var table = `
    <h2 ${css.f15}>Customers Vs Profits Amounts: This is a financial document that provides information about money 
                        earned to a company by its customers or clients for goods or services provided on credit.</h2>
    <table ${css.table} class="dt-alterColor">
     <tr >
       <th ${css.th}>Customer</th>
       <th ${css.th}>Last 24 hours</th>
       <th ${css.th}>Last 7 days</th>
       <th ${css.th}>Last 15 days</th>
       <th ${css.th}>Last 30 days</th>
       <th ${css.th}>Last 90 days</th>
       <th ${css.th}>Over 90 days</th>
       <th ${css.th}>Total</th>   
       </tr> 
         `

    if (!data || data.length == 0) {
        table += `
                <tr>
                    <td ${css.td} colspan="8"  ><div align="center"><h3>No Profits Were Found.</h3></div></td>
                </tr> 
                 </table>`
        return table;
    }

    function cleanMoney(val) {
        if (val === undefined || val === null) return 0;
        if (typeof val === 'number') return val;
        return parseFloat(val.toString().replace(/[$,]/g, '')) || 0;
    }

    for (let i = 0; i < data.length; i++) {
        const item = data[i];

        let val_24 = cleanMoney(item.last_24_hours);
        let val_7 = cleanMoney(item.last_7_days);
        let val_15 = cleanMoney(item.last_15_days);
        let val_30 = cleanMoney(item.last_30_days);
        let val_90 = cleanMoney(item.last_90_days);
        let val_o90 = cleanMoney(item.over_90_days);

        let inc_24 = cleanMoney(item.last_24_hours_income);
        let inc_7 = cleanMoney(item.last_7_days_income);
        let inc_15 = cleanMoney(item.last_15_days_income);
        let inc_30 = cleanMoney(item.last_30_days_income);
        let inc_90 = cleanMoney(item.last_90_days_income);
        let inc_o90 = cleanMoney(item.over_90_days_income);

        let t_earnings = cleanMoney(item.total_earnings);

        let detailHtml_24_hours = val_24 > 0 ? `class='tdClick' data-detail='{"click": [ {"dest":"ripple" }, {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${item.customer_id}", "source":"dt", "period":"1" } ] }'` : '';
        let detailHtml_7_days = val_7 > 0 ? `class='tdClick' data-detail='{"click": [ {"dest":"ripple" }, {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${item.customer_id}", "source":"dt", "period":"2" } ] }'` : '';
        let detailHtml_15_days = val_15 > 0 ? `class='tdClick' data-detail='{"click": [ {"dest":"ripple" }, {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${item.customer_id}", "source":"dt", "period":"3" } ] }'` : '';
        let detailHtml_30_days = val_30 > 0 ? `class='tdClick' data-detail='{"click": [ {"dest":"ripple" }, {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${item.customer_id}", "source":"dt", "period":"4" } ] }'` : '';
        let detailHtml_90_days = val_90 > 0 ? `class='tdClick' data-detail='{"click": [ {"dest":"ripple" }, {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${item.customer_id}", "source":"dt", "period":"5" } ] }'` : '';
        let detailHtml_over_90_days = val_o90 > 0 ? `class='tdClick' data-detail='{"click": [ {"dest":"ripple" }, {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${item.customer_id}", "source":"dt", "period":"6" } ] }'` : '';

        totals.total_last_24_hours += val_24;
        totals.total_last_24_hours_income += inc_24;
        totals.total_last_7_days += val_7;
        totals.total_last_7_days_income += inc_7;
        totals.total_last_15_days += val_15;
        totals.total_last_15_days_income += inc_15;
        totals.total_last_30_days += val_30;
        totals.total_last_30_days_income += inc_30;
        totals.total_last_90_days += val_90;
        totals.total_last_90_days_income += inc_90;
        totals.total_over_90_days += val_o90;
        totals.total_over_90_days_income += inc_o90;
        totals.grandTotal += t_earnings;

        let percentage_24_hours = safePercentage(val_24, inc_24);
        let percentage_7_days = safePercentage(val_7, inc_7);
        let percentage_15_days = safePercentage(val_15, inc_15);
        let percentage_30_days = safePercentage(val_30, inc_30);
        let percentage_90_days = safePercentage(val_90, inc_90);
        let percentage_over_90_days = safePercentage(val_o90, inc_o90);

        table += `
            <tr ${rowStyle(i)}>
              <td ${css.td}>${item.customer_name}</td>
              <td ${css.td} ${detailHtml_24_hours}>
                  ${cashVal(inc_24)}<br>${cashVal(val_24)}<br><small>${math.percentFormat(percentage_24_hours)}</small>
              </td>
              <td ${css.td} ${detailHtml_7_days}>
                  ${cashVal(inc_7)}<br>${cashVal(val_7)}<br><small>${math.percentFormat(percentage_7_days)}</small>
              </td>
              <td ${css.td} ${detailHtml_15_days}>
                  ${cashVal(inc_15)}<br>${cashVal(val_15)}<br><small>${math.percentFormat(percentage_15_days)}</small>
              </td>
              <td ${css.td} ${detailHtml_30_days}>
                  ${cashVal(inc_30)}<br>${cashVal(val_30)}<br><small>${math.percentFormat(percentage_30_days)}</small>
              </td>
              <td ${css.td} ${detailHtml_90_days}>
                  ${cashVal(inc_90)}<br>${cashVal(val_90)}<br><small>${math.percentFormat(percentage_90_days)}</small>
              </td>
              <td ${css.td} ${detailHtml_over_90_days}>
                  ${cashVal(inc_o90)}<br>${cashVal(val_o90)}<br><small>${math.percentFormat(percentage_over_90_days)}</small>
              </td>
              <td ${css.td}>${cashVal(t_earnings)}</td>
            </tr> 
        `
        nextFormat = i + 1;
    }

    let t_perc_24 = safePercentage(totals.total_last_24_hours, totals.total_last_24_hours_income);
    let t_perc_7 = safePercentage(totals.total_last_7_days, totals.total_last_7_days_income);
    let t_perc_15 = safePercentage(totals.total_last_15_days, totals.total_last_15_days_income);
    let t_perc_30 = safePercentage(totals.total_last_30_days, totals.total_last_30_days_income);
    let t_perc_90 = safePercentage(totals.total_last_90_days, totals.total_last_90_days_income);
    let t_perc_o90 = safePercentage(totals.total_over_90_days, totals.total_over_90_days_income);

    table += `
        <tr ${rowStyle(nextFormat)}>
          <td style="text-align: right;"><h2>Total</h2></td>
          <td ${css.td} ><h5>${cashVal(totals.total_last_24_hours_income)}<br>${cashVal(totals.total_last_24_hours)}<br>${math.percentFormat(t_perc_24)}</h5></td>
          <td ${css.td} ><h5>${cashVal(totals.total_last_7_days_income)}<br>${cashVal(totals.total_last_7_days)}<br>${math.percentFormat(t_perc_7)}</h5></td>
          <td ${css.td} ><h5>${cashVal(totals.total_last_15_days_income)}<br>${cashVal(totals.total_last_15_days)}<br>${math.percentFormat(t_perc_15)}</h5></td>
          <td ${css.td} ><h5>${cashVal(totals.total_last_30_days_income)}<br>${cashVal(totals.total_last_30_days)}<br>${math.percentFormat(t_perc_30)}</h5></td>
          <td ${css.td} ><h5>${cashVal(totals.total_last_90_days_income)}<br>${cashVal(totals.total_last_90_days)}<br>${math.percentFormat(t_perc_90)}</h5></td>
          <td ${css.td} ><h5>${cashVal(totals.total_over_90_days_income)}<br>${cashVal(totals.total_over_90_days)}<br>${math.percentFormat(t_perc_o90)}</h5></td>
          <td ${css.td} ><h4>${cashVal(totals.grandTotal)}</h4></td>
        </tr> 
        `

    table += `</table>`
    return table
}

function safePercentage(numerator, denominator) {
    if (!denominator || denominator === 0 || isNaN(denominator)) {
        return "0.00";
    }
    let num = (typeof numerator === 'number') ? numerator : 0;
    return parseFloat((num / denominator) * 100).toFixed(2);
}

function cashVal(value) {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function rowStyle(i) {
    if (i % 2 === 0) { return '' }
    return css.trGray
}